import React from "react";
import { Reveal } from "@/components/Reveal";
import { SectionHeading } from "@/components/sections/SectionHeading";
import { FEE_ROWS } from "@/data/content";
import { ArrowUpRight, ShieldCheck } from "lucide-react";

export const Transparency = () => {
  return (
    <section id="fees" data-testid="fees" className="relative bg-ivory py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="grid items-start gap-14 lg:grid-cols-[0.9fr_1.1fr]">
          <SectionHeading
            overline="Trust & security"
            title="No hidden charges. Ever."
            accentWord="No hidden charges."
            subtitle="Every rupee is accounted for. See exactly what you pay, how we make money, and proof your gold is really there."
          />

          <Reveal>
            <div className="glass-card overflow-hidden rounded-3xl p-2">
              <div className="rounded-2xl bg-white/50 p-6 sm:p-8">
                <div className="flex items-center gap-2 text-sm font-semibold text-charcoal">
                  <ShieldCheck className="h-5 w-5 text-gold" /> Fee breakdown · Core plan
                </div>
                <div className="mt-6 divide-y divide-amber-200/50">
                  {FEE_ROWS.map((row) => (
                    <div key={row.label} className="flex items-center justify-between py-4">
                      <div>
                        <p className="font-medium text-charcoal">{row.label}</p>
                        <p className="text-xs text-charcoal-soft">{row.note}</p>
                      </div>
                      <p className="font-serif text-xl text-gold-gradient">{row.value}</p>
                    </div>
                  ))}
                </div>
                <div className="mt-6 flex flex-wrap gap-3">
                  <a href="#pricing" className="inline-flex items-center gap-1 rounded-full border border-amber-200/60 bg-white/60 px-4 py-2 text-sm font-medium text-charcoal transition-colors hover:border-gold hover:text-gold">
                    How we make money <ArrowUpRight className="h-4 w-4" />
                  </a>
                  <a href="#fees" className="inline-flex items-center gap-1 rounded-full border border-amber-200/60 bg-white/60 px-4 py-2 text-sm font-medium text-charcoal transition-colors hover:border-gold hover:text-gold">
                    View vault audit <ArrowUpRight className="h-4 w-4" />
                  </a>
                </div>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
